import { gql } from "@apollo/client";

const MARK_CREDIT_AS_NOT_TRACK_NEEDED = gql`
  mutation UpdateCredit($input: UpdateCreditInput!) {
    updateCredit(input: $input) {
      credit {
        id
        trackNeeded
      }
    }
  }
`;

export default MARK_CREDIT_AS_NOT_TRACK_NEEDED;
